export const SOURCING_EVENT_NAMES = {
  VIEWED_SOURCE_INSTANT: 'Viewed Source Instant Properties page',
  VIEWED_SOURCE_NON_INSTANT: 'Viewed Source Non-Live Properties page',
  VIEWED_CONTACT_PROVIDERS: 'Viewed Contact Providers page',
  PROPERTY_ADDED_TO_SHORTLIST: 'Property added to Shortlist in Sourcing flow',
  PROVIDER_PROFILE_ADDED_ON_STEP_1:
    'Provider profile added to Contact list on Step 1',
  PROVIDER_PROFILE_ADDED_ON_STEP_2:
    'Provider profile added to Contact list on Step 2',
  PROVIDER_PROFILE_ADDED_ON_STEP_3:
    'Provider profile added to Contact list on Step 3',
  EMAIL_SENT_TO_PROVIDERS: 'Request email sent to Providers',
  EMAIL_SENT_TO_SELF: 'Request email sent to Self',
} as const
